import { RESOURCE_NAME } from '@esentai/core/features/users/consts';
import { canRead, canUpdate } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canReadUser = authorizeIf(canRead(RESOURCE_NAME));
export const canReadUsers = authorizeIf(canRead(RESOURCE_NAME));
export const canUpdateUser = authorizeIf(canUpdate(RESOURCE_NAME));
